module.exports = __webpack_public_path__ + "static/assets/61c7a9fd0ca532452ff3c30495052b9c.svg";